import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule, } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { ServiceGridViewModel, } from "../../store/models/service/servicelist";
import { ServiceModel, } from "../../store/models/service/AddService";
import { ServiceEditModel, } from "../../store/models/service/UpdateService";
import { ServiceDetailViewModel, } from "../../store/models/service/ViewService";
import { getTenantId } from "@/store/helper";
let ServiceModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    let ServiceModule = class ServiceModule extends VuexModule {
        constructor() {
            super(...arguments);
            //List
            this.services = [];
            //Update
            this.updateService = null;
            //View
            this.viewService = null;
            this.apiNode = "Service";
        }
        //GridView
        async GetServices() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.ListServices(plainToClass(ServiceGridViewModel, data.service));
                return data;
            }
        }
        //Save
        async saveService(saveService) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, saveService);
        }
        //Get Service Details for Edit
        async GetServiceById(serviceId) {
            var url = `${getTenantId()}/${this.apiNode}/` + serviceId;
            let { data } = await service.get(url);
            if (data) {
                this.GetSelectedService(plainToClass(ServiceEditModel, data.editService));
                return data;
            }
        }
        //Update
        async EditServiceById(updateService) {
            var url = `${getTenantId()}/${this.apiNode}/` + "updateService";
            let { data } = await service.put(url, updateService);
        }
        //ViewService
        async GetServiceDetailById(viewId) {
            var url = `${getTenantId()}/${this.apiNode}/` + viewId + "/ServiceId";
            let { data } = await service.get(url);
            if (data) {
                this.ViewSelectedService(plainToClass(ServiceDetailViewModel, data.viewService));
                return data;
            }
        }
        async DeleteService(deleteId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "DeleteService/" + deleteId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        //listing
        ListServices(Service) {
            this.services = Service;
        }
        //Update
        GetSelectedService(service) {
            this.updateService = service;
        }
        //View
        ViewSelectedService(service) {
            this.viewService = service;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], ServiceModule.prototype, "GetServices", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ServiceModel !== "undefined" && ServiceModel) === "function" ? _b : Object]),
        __metadata("design:returntype", Promise)
    ], ServiceModule.prototype, "saveService", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof Guid !== "undefined" && Guid) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], ServiceModule.prototype, "GetServiceById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof ServiceEditModel !== "undefined" && ServiceEditModel) === "function" ? _e : Object]),
        __metadata("design:returntype", Promise)
    ], ServiceModule.prototype, "EditServiceById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof Guid !== "undefined" && Guid) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], ServiceModule.prototype, "GetServiceDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof Guid !== "undefined" && Guid) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], ServiceModule.prototype, "DeleteService", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ServiceModule.prototype, "ListServices", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof ServiceEditModel !== "undefined" && ServiceEditModel) === "function" ? _k : Object]),
        __metadata("design:returntype", void 0)
    ], ServiceModule.prototype, "GetSelectedService", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof ServiceDetailViewModel !== "undefined" && ServiceDetailViewModel) === "function" ? _l : Object]),
        __metadata("design:returntype", void 0)
    ], ServiceModule.prototype, "ViewSelectedService", null);
    ServiceModule = __decorate([
        Module({ dynamic: true, store: store, name: "services", namespaced: true })
    ], ServiceModule);
    return ServiceModule;
})();
export default getModule(ServiceModule);
